import { dateTimeTypePolicy } from "./scalar-types";

export const scalarTypePolicies = {
  Beneficiary: {
    fields: { createdAt: dateTimeTypePolicy, terminatedAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  BeneficiaryDelivery: { fields: { receivedAt: dateTimeTypePolicy } },
  BeneficiaryTransactionSet: { fields: { receivedAt: dateTimeTypePolicy } },
  CaseRecommendation: { fields: { generatedAt: dateTimeTypePolicy } },
  ExecutionResultArtifact: { fields: { createdAt: dateTimeTypePolicy } },
  Partner: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PartnerGroup: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  QualityAssessment: { fields: { performedAt: dateTimeTypePolicy } },
  ResourceSnapshotResult: { fields: { computedAt: dateTimeTypePolicy } },
  RpaForecastEntry: { fields: { dispatchAt: dateTimeTypePolicy } },
  RpaLinkView: { fields: { createdAt: dateTimeTypePolicy, lastSessionAt: dateTimeTypePolicy } },
  RpaSessionDot: { fields: { startedAt: dateTimeTypePolicy } },
  UserHealthRecord: { fields: { updatedAt: dateTimeTypePolicy } },
  UserUploadedDocumentsResult: { fields: { createdAt: dateTimeTypePolicy } },
  WebAgentExecutionResult: { fields: { createdAt: dateTimeTypePolicy } },
};
